import React from 'react';
import { Icon, channelIconName, channelColor } from '@/components/ui/Icon';

/** Small channel badge overlaid on an avatar (web/email/whatsapp/messenger/sms). */
export const ChannelDot: React.FC<{ channel: string; size?: number }> = ({ channel, size = 18 }) => {
  return (
    <span
      className="ac-conv-ch"
      style={{ background: channelColor(channel), color: '#fff', width: size, height: size }}
    >
      <Icon name={channelIconName(channel)} size={Math.round(size * 0.6)} stroke={2} />
    </span>
  );
};
